import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { STRINGS_CIBIO } from '../../../../util/authorizationsCIBIO/string';
import { STRINGS } from '../../../../util/strings';
import If from '../../../../components/If';
import Loading from '../../../../components/Loading';
import Button from '../../../../components/Button';
import EditButton from '../../../../components/EditButton';
import SearchEmpty from '../../../../components/SearchEmpty';
import AlertError from '../../../../components/AlertError';
import { EventResult } from '../../../../models/modelsAuthorizationsCIBIO';
import { statusToText } from '../../../../functions/formatStatus';
import api from '../../../../services/api';
import '../../../Cultivares/styles_list.css';

export default function Event ()
{
	const history = useHistory();
	const [events, setEvents] = useState<EventResult[]>([]);
	const [errorSearch, setErrorSearch] = useState<any>(null);
	const [errorGetEvents, setErrorGetEvents] = useState<any>(null);
	const [emptySearch, setEmptySearch] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSearch, setLoadingSearch] = useState<boolean>(false);

	const { register, handleSubmit, getValues } = useForm({
		defaultValues: { name: '', active: true },
	})

	useEffect(() => {
		const getCultures = async () => {
			try {
				const { data, status } = await api.get<EventResult[]>('api/v1/autorizacoes-cibio/Evento/obterporfiltro?Ativo=true');

				if (status === 200) {
					setEvents(data);
				}
			} catch (error:any) {
				setErrorGetEvents(error.response.data);
			}
			setLoading(false);
		}

		getCultures();
	}, []);

	const search = async () => {
		let nome = getValues('name');
		let ativo = getValues('active');
		setLoadingSearch(true);
		setErrorSearch(null);

		try {
			const { data } = await api.get<EventResult[]>(`api/v1/autorizacoes-cibio/Evento/obterporfiltro?Nome=${nome}&Ativo=${ativo}`);

			if (data.length) {
				setEvents(data);
				setEmptySearch(false);
			} else {
				setEmptySearch(true);
			}

		} catch (error:any) {
			setErrorSearch(error.response.data);
		}
		setLoadingSearch(false);
	}

	const actions = ({ data }: any) => (
		<Fragment>
			<EditButton
				onClick={() => history.push({
					pathname: '/autorizacoes/editar/evento',
					state: {
						id: data.id
					}
				})}
			/>
		</Fragment>
	)

	return <div className="container-custom-search">
		<If condition={errorGetEvents !== null && !events.length}>
			{errorGetEvents !== null && errorGetEvents.message.length > 0 ? errorGetEvents.message.map((error: string) => <AlertError message={error} />) : <AlertError message={STRINGS.ALERT_GENERIC_ERROR} />}
		</If>
		<If condition={errorSearch !== null && !events.length}>
			{errorSearch !== null && errorSearch.message.length > 0 ? errorSearch.message.map((error: string) => <AlertError message={error} />) : <AlertError message={STRINGS.ALERT_GENERIC_ERROR} />}
		</If>
		<div className="top-content">
			<h3>{STRINGS_CIBIO.SEARCH_EVENT}</h3>
		</div>
		<div className="row-buttons">
			<Button
				onClick={() => history.push('/autorizacoes/cadastrar/evento')}
				contained
				title="Adicionar"
				type="button"
			/>
		</div>
		<br />
		<Form onSubmit={handleSubmit(search)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col} md={8}>
					<Form.Label>Nome do evento</Form.Label>
					<Form.Control
						ref={register}
						name="name"
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label />
					<Form.Check
						type="checkbox"
						ref={register}
						name="active"
						label="Ativos"
					/>
				</Form.Group>
				<span className="filter-btn">
					<Button
						title="Buscar"
						type="submit"
						contained
						isLoading={loadingSearch}
					/>
				</span>
			</Form.Row>
		</Form>
		<If condition={!loading && !emptySearch && events.length}>
			<div className="search-content">
				<div className="ag-theme-alpine" style={{ height: '70vh', width: '100%' }}>
					<AgGridReact
						rowData={events}
						defaultColDef={{ flex: 1, sortable: true, resizable: true }}
						pagination
						paginationPageSize={10}
						frameworkComponents={{
							actions: actions,
						}}
					>
						<AgGridColumn
							headerName='Nome do evento'
							field="nome"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName="Status"
							field="ativo"
							valueFormatter={({ data }: any) => statusToText(data.ativo)}
							maxWidth={130}
						/>
						<AgGridColumn
							field='Ações'
							cellRenderer='actions'
							maxWidth={130}
						/>
					</AgGridReact>
				</div>
			</div>
		</If>
		<If condition={loading}>
			<div className="loading-container">
				<Loading />
			</div>
		</If>
		<If condition={emptySearch}>
			<div className="div-empty">
				<SearchEmpty />
			</div>
		</If>
	</div>;
}